
import { IAppointmentIn, IAppointmentFileIn } from "../../models/input/agendaApi/IAppointmentIn";
import * as ApiWithToken from "../callApiWithToken";

const appointmentService = {
  getAppointmentByUser: async function () {
    return ApiWithToken.getApi(
      process.env.REACT_APP_AGENDAS_API + `Appointment/GetAppointmentWeb`
    );
  },
  getAppointmentByUserCheckIn: async function () {
    return ApiWithToken.getApi(
      process.env.REACT_APP_AGENDAS_API + `Appointment/GetAppointment`
    );
  },
  getTypeOfAppointmentListByRoleType: async function (
    roleTypeId: number,
    languageId: number
  ) {
    return ApiWithToken.getApi(
      process.env.REACT_APP_AGENDAS_API +
        `Appointment/GetTypeOfAppointmentListByRoleType?RoleTypeID=${roleTypeId}&LanguageID=${languageId}`
    );
  },
  getSubretailList: async function () {
    return ApiWithToken.getApi(
      process.env.REACT_APP_AGENDAS_API + `Appointment/GetSubretailList`
    );
  },
  getPosListBySubretailList: async function (subretailList: string) {
    return ApiWithToken.getApi(
      process.env.REACT_APP_AGENDAS_API +
        `Appointment/GetPosListBySubretailList?SubretailList=${subretailList}`
    );
  },
  postAppointment: async function (appointmentIn: IAppointmentIn) {
    return ApiWithToken.postApi(
      process.env.REACT_APP_AGENDAS_API + `Appointment/CreateAppointment`,
      appointmentIn
    );
  },
  getAppointmentByAdvisor: async function (
    advisorId: number,
    languageId: number
  ) {
    return ApiWithToken.getApi(
      process.env.REACT_APP_AGENDAS_API +
        `Appointment/GetAppointmentByAdvisor?IdAdvisor=${advisorId}&LanguageID=${languageId}`
    );
  },
  deleteAppointment: async function (appointmentId: number) {
    return ApiWithToken.deleteApi(
      process.env.REACT_APP_AGENDAS_API +
        `Appointment/DeleteAppointment?AppointmentId=${appointmentId}`
    );
  },
  updateAppointment: async function (appointmentUpdateIn: IAppointmentIn) {
    return ApiWithToken.putApi(
      process.env.REACT_APP_AGENDAS_API +
        `Appointment/UpdateAppointmentInformation`,
      appointmentUpdateIn
    );
  },
  getPosCoordinates: async function (posList: string) {
    return ApiWithToken.getApi(
      process.env.REACT_APP_AGENDAS_API +
        `Appointment/GetPosCoordinates?PosList=${posList}`
    );
  },
  postAppointmentFile: async function (appointmentFileIn: IAppointmentFileIn) {
    return ApiWithToken.postApi(
      process.env.REACT_APP_AGENDAS_API +
        `Appointment/CreateAppointmentFromFile`,
      appointmentFileIn
    );
  },
  getSubretailByCountries: async function (countryIDs: string) {
    return ApiWithToken.getApi(
      process.env.REACT_APP_AGENDAS_API + `Appointment/GetSubretailByCountries?CountryIDs=${countryIDs}`
    );
  },

  getAgendaTemplate: async function (agendatypeID: number) {
      return ApiWithToken.getApiBlob(process.env.REACT_APP_AGENDAS_API + `AngendaManagement/GetAgendaTemplate?agendaTypeID=${agendatypeID}`);
  }




};
export default appointmentService;
